export type DashboardStep = "workspace" | "keyfile" | "register" | "grant" | "publish";

export type DashboardFlowState = {
  workspaceConfigured: boolean;
  keyGenerated: boolean;
  keyDownloadConfirmed: boolean;
  publicRegistered: boolean;
  grantConfirmed: boolean;
  versionPublished: boolean;
  keyLabel: string;
  publicKeyId: string;
  signingKeyId: string;
  expandedStep: DashboardStep;
  updatedAt: string;
};

export const dashboardFlowStorageKey = "envship-dashboard-flow";

export function defaultDashboardFlow(): DashboardFlowState {
  return {
    workspaceConfigured: false,
    keyGenerated: false,
    keyDownloadConfirmed: false,
    publicRegistered: false,
    grantConfirmed: false,
    versionPublished: false,
    keyLabel: "mrlinvest-browser-key",
    publicKeyId: "",
    signingKeyId: "",
    expandedStep: "workspace",
    updatedAt: ""
  };
}

export function normalizeDashboardFlow(parsed: Partial<DashboardFlowState> & { keyCreated?: boolean }): DashboardFlowState {
  if (typeof parsed.workspaceConfigured === "undefined") return defaultDashboardFlow();
  return {
    ...defaultDashboardFlow(),
    ...parsed,
    keyGenerated: parsed.keyGenerated ?? parsed.keyCreated ?? false,
    keyDownloadConfirmed: parsed.keyDownloadConfirmed ?? false,
    expandedStep: parsed.expandedStep ?? "workspace"
  };
}

export function stepState(flow: DashboardFlowState, step: DashboardStep) {
  if (step === "workspace") return flow.workspaceConfigured ? "complete" : "active";
  if (step === "keyfile") {
    if (!flow.workspaceConfigured) return "locked";
    return flow.keyDownloadConfirmed ? "complete" : "active";
  }
  if (step === "register") {
    if (!flow.keyDownloadConfirmed) return "locked";
    return flow.publicRegistered ? "complete" : "active";
  }
  if (step === "grant") {
    if (!flow.publicRegistered) return "locked";
    return flow.grantConfirmed ? "complete" : "active";
  }
  if (!flow.grantConfirmed) return "locked";
  return flow.versionPublished ? "complete" : "active";
}

export function grantStatus(flow: DashboardFlowState, hasActiveWorkspace: boolean) {
  if (!hasActiveWorkspace) return "Setup required";
  if (!flow.keyGenerated) return "No key registered";
  if (!flow.keyDownloadConfirmed) return "KeyFile save required";
  if (!flow.publicRegistered) return "Public key ready";
  if (!flow.grantConfirmed) return "Awaiting grant";
  if (!flow.versionPublished) return "Granted";
  return "Included in current version";
}
